import { PURCHASE_METHOD_CASH, PURCHASE_METHOD_NORMAL_FINANCE, PURCHASE_METHOD_ARIB, PURCHASE_METHOD_TAMRA, PURCHASE_METHOD_TABBY, PURCHASE_METHOD_AMWAL, PURCHASE_METHOD_CREDIT_CARD } from "@/common/Contexts/CheckoutOrderContext";
export function sectionToPurchaseMethod(methodType) {
  switch (methodType) {
    case "cash":
      return PURCHASE_METHOD_CASH;
    case "free_finance":
      return PURCHASE_METHOD_NORMAL_FINANCE;
    case "arib_finance":
      return PURCHASE_METHOD_ARIB;
    default:
      return null;
  }
}
export function bnplItemToPurchaseMethod(methodType) {
  switch (methodType) {
    case "tamara":
      return PURCHASE_METHOD_TAMRA;
    case "tabby":
      return PURCHASE_METHOD_TABBY;
    case "credit_card":
      return PURCHASE_METHOD_CREDIT_CARD;
    case "amwal":
      return PURCHASE_METHOD_AMWAL;
    default:
      return null;
  }
}